import React, { RefObject } from 'react'

const ScrollContext = React.createContext<RefObject<HTMLElement>>({
  current: null,
})

export default ScrollContext